export default __webpack_public_path__ + "static/media/498.071b7d42.gif";